export * from './StarIcon';
export * from './StarIcon16Light';
export * from './StarIcon16Regular';
export * from './StarIcon16Solid';
export * from './StarIcon20Light';
export * from './StarIcon20Regular';
export * from './StarIcon20Solid';
export * from './StarIcon24Regular';
export * from './StarIcon24Solid';
export * from './StarIcon32Regular';
export * from './StarIcon64Regular';
